import { useMemo } from 'react';
import { getLinkifiedText } from './helpers';

const useEncodeUriTeams = (value: string | undefined): { result: string } => {
  const result = useMemo(() => getLinkifiedText(value), [value]);

  return { result };
};

export default useEncodeUriTeams;
